import { cilFolderOpen } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CBreadcrumb,
  CBreadcrumbItem,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CContainer,
  CFormLabel,
  CHeaderDivider,
  CRow,
} from "@coreui/react";
import { useQuery } from "@tanstack/react-query";
import debounce from "debounce";
import { useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { fetchCustomerListApi1 } from "../Helper/order";
import { OutstandingList } from "../Helper/outstanding";
import "./TotalOutstanding.css";


export default function TotalOutstanding() {
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState();
  const [perPage, setPerPage] = useState(10);
  const userData = useSelector((state) => state.userData);
  const [customerList, setCustomerList] = useState();
  const [listLoading, setListLoading] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [paidOption,setPaidOption]=useState("unpaid");
  const [totalRecords,setTotalRecords]=useState(0);
  const [offset, setOffset] = useState(0);
  const [debounceSearch, setDebounceSearch] = useState("");
  const [appliedCustomer, setAppliedCustomer] = useState("");
  const [appliedPaidOption, setAppliedPaidOption] = useState("unpaid");
 
  const columns = [
    {
      name: " No",
      selector: (row, index) => index + 1,
    },
    {
      name: "Customer Name",
      selector: (row) => row.customerName,
    },
    {
      name: "Customer Phone",
      selector: (row) => row.customerPhone,
    },

    {
      name: "Total Outstanding",
      selector: (row) => row.totalOutStanding,
    },
    {
      name: "Total Paid",
      selector: (row) => row.totalPaid,
    },
    {
      name: "Balance",
      selector: (row) => row.remainingAmount,
    },
    // {
    //   name: 'Type',
    //   selector: row => row.type,
    // },
    {
      name: "View",
      selector: (row) => (
        <>
          <Link to={"/outstandingViewList/" + row.customerId}>
            <CButton
              color="secondary"
              title="View Outstanding"
              variant="outline"
              className="px-0 buttonsOrderPage "
            >
              <CIcon icon={cilFolderOpen} size="lg" />
            </CButton>
          </Link>
        </>
      ),
    },
  ];

  let userId = userData.userinfo.userId;

  const paymentOptions = [
    // { value: "full paid", label: "Paid" },
    { value: "unpaid", label: "Unpaid" },
    // { value: "partial paid", label: "Partially Paid" },
  ];

  function handlePageChange(page) {
    setListLoading(true);
    const offset = (page - 1) * perPage;
    setOffset(offset);
  }

  // useEffect(() => {
  //   handlePageChange(0);
  // }, []);

  // useEffect(() => {
  //   if (inputValue !== "") {
  //     setTimeout(() => {
  //       getCutomerlist();
  //     }, 200);
  //   }
  // }, [inputValue])


  const { data: outStandingData, isLoading: outStandingIsLoading, refetch: outStandingRefetch } = useQuery({
    queryKey: ['outstanding-list', offset, appliedCustomer, appliedPaidOption],
    queryFn: () => OutstandingList(userId, offset < 0 ? 0 : offset, appliedCustomer, appliedPaidOption),
    gcTime: Infinity,
    staleTime: 0,
  });

  const paginationComponentOptions = {
    rowsPerPageText: "",
    noRowsPerPage: true,
  };

  const debouncedSearch = useCallback(
    debounce((value) => setDebounceSearch(value), 800),
    []
  );

  const getCutomerlist = () => {
    fetchCustomerListApi1(debounceSearch).then((res) => {
      var result = res?.data;
      var customerLive = [];
      result.forEach((element) => {
        customerLive.push({
          value: element.customerId,
          label: element.customerName,
        });
      });
      setCustomerList(customerLive);
    });
  };

  useEffect(() => {
    getCutomerlist();
  }, [debounceSearch]);

  const handleCustomer = (e) => {
    setSelectedCustomer(e?.value || "");
  };

  const handleInputChange = (value) => {
    setInputValue(value)
  }

  const handlePayment = (selectionOption) => {
    setPaidOption(selectionOption?.value || "");
  };

  const handleSearch = async () => {
    setAppliedCustomer(selectedCustomer);
    setAppliedPaidOption(paidOption);
    setOffset(0);
  };

  const handleClear = async (e) => {
    setPaidOption("unpaid");
    setSelectedCustomer("");
    setDebounceSearch("");
    setAppliedPaidOption("unpaid");
    setAppliedCustomer("");
    setOffset(0);
  };

  const customStyles = {
    cells: {
      style: {
        borderRight: "1px solid #ddd",
        borderLeft: "1px solid #ddd"
      },
    },
    rdt_TableHeadRow: {
      style: {
        borderRight: "1px solid #ddd",
        borderLeft: "1px solid #ddd"
      },
    }
  };

  const handleSearchChange = (inputValue) => {
    if (inputValue) {
      debouncedSearch(inputValue);
    }
  }


  return (
    <div>
      <CHeaderDivider />
      <CContainer fluid>
        <CRow>
          <CCol xs={12}>
            <h5 className="main-title">Outstanding </h5>
          </CCol>
          <CCol xs={8}>
            <CBreadcrumb
              className="m-0 ms-2"
              style={{ "--cui-breadcrumb-divider": "'>'" }}
            >
              <CBreadcrumbItem>
                {" "}
                <Link to="/dashboard">Home</Link>
              </CBreadcrumbItem>
              <CBreadcrumbItem actives>Total Outstanding</CBreadcrumbItem>
            </CBreadcrumb>
          </CCol>
          <CCol xs={4}></CCol>
        </CRow>
      </CContainer>

      <CRow className="justify-content-center">
        <CCol md={12} lg={12} sm={12}>
          <CCard style={{ margin: "10px" }} className="mb-4">
            <CCardHeader>
              <strong>Total Outstanding</strong>
            </CCardHeader>
            <CCardBody>
              <CRow className="">
                <CCol md={12}>
                  <CFormLabel>
                    <b>Filter:</b>
                  </CFormLabel>
                </CCol>

                <CCol md={3}>
                  <CFormLabel>Customer Name</CFormLabel>
                  <Select
                    options={customerList}
                    placeholder={
                      <div className="select-placeholder-text">
                        Select Customer
                      </div>
                    }
                    className="text-start mb-3"
                    value={customerList?.find(
                      (obj) => obj.value === selectedCustomer
                    ) || null}
                    onChange={handleCustomer}
                    onInputChange={handleSearchChange}
                    isClearable
                    isSearchable
                  />
                </CCol>

                <CCol md={3}>
                  <CFormLabel>Payment</CFormLabel>
                  <Select
                    options={paymentOptions}
                    placeholder={
                      <div className="select-placeholder-text">
                        Select Payments
                      </div>
                    }
                    value={
                      paymentOptions?.find((obj) => obj.value === paidOption) || ""
                    }
                    onChange={handlePayment}
                    isClearable
                  />
                </CCol>

                <br />
                <CCol md={12}>
                  <div className="text-center mt-2">
                    <CButton
                      color="success"
                      className="m-2 text-white"
                      onClick={handleSearch}
                    >
                      Search
                    </CButton>
                    <CButton
                      color="dark"
                      className="text-white"
                      onClick={handleClear}
                    >
                      Clear
                    </CButton>
                  </div>
                </CCol>
              </CRow>

              {/* <DataTable
                className=" mt-3 "
                columns={columns}
                data={data}
                highlightOnHover
                pagination
                paginationServer
                progressPending={listLoading}
                paginationRowsPerPageOptions={[]}
                paginationComponentOptions={paginationComponentOptions}
                paginationTotalRows={totalRecords}
                onChangePage={handlePageChange}
                customStyles={customStyles}
              /> */}

              <DataTable
                className="tableTopSpace "
                columns={columns}
                responsive={true}
                data={outStandingData?.data}
                progressPending={outStandingIsLoading}
                paginationTotalRows={outStandingData?.totalRecords}
                onChangePage={handlePageChange}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                customStyles={customStyles}
                paginationServer
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}
